export class Client {
    id:any;
    name:any;
    full_name:any;
    status:any;
    indirizzo:any;
    emailcertificati:any;
}
